import React, { useContext, useState, useEffect } from "react";
import { ProductsContext } from "../context/ProductsContext";
import "./home.css";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useLanguage } from "../context/LanguageContext"; // Import the context
import heroImage from "../assets/hero.png";
import offer1 from "../assets/offer1.png";
import yearsIcon from "../assets/years.png";
import guaranteeIcon from "../assets/guarantee.png";
import professionalIcon from "../assets/professional.png";
import iphone17 from "../assets/iphone17.jpg";
import samsungS25 from "../assets/samsung.jpg";
import xiomi17 from "../assets/xiomi.png";
import apple from "../assets/apple.png";
import samsung from "../assets/samsunglogo.jpg";
import xiaomi from "../assets/xiaomilogo.png";
import huawei from "../assets/huawei.jpeg";
import { API_BASE_URL } from "../config/api";

export default function Home() {
  const { lang } = useLanguage(); // Get current language from context
  const { products, fetchProducts } = useContext(ProductsContext);
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);

  const t = {
    sq: {
      heroTitle: "Teknologjia më e fundit në duart tuaja",
      heroSub: "Smartphone, aksesorë dhe shërbime profesionale",
      explore: "Shiko Ofertat",
      offers: "Oferta Speciale",
      about: "Rreth Nesh",
      aboutText:
        "Masterphone  është destinacioni juaj i besueshëm për shërbime të telefonave tuaj smartphone dhe teknologji mobile në zemër të Tiranës. Me 20 vite përvojë në riparimin e telefonëve, pajisjeve dhe aksesorëve, ne ofrojmë shërbime të shpejta, të sigurta dhe me cilësi të lartë.Ekipi ynë profesional është i përkushtuar të sigurojë zgjidhje të menjëhershme për çdo problem teknik, duke u fokusuar gjithmonë tek kënaqësia e klientit. Që nga riparimi i ekranit dhe baterive, deri te konfigurimet dhe këshillat për përdorim optimal, Masterphone Tirana është partneri juaj i besueshëm në botën e teknologjisë mobile.Vizitoni Masterphone  dhe përjetoni shërbimin që kombinon profesionalizëm, përkushtim dhe besueshmëri.",
      why: "Pse të na zgjidhni?",
      fast: "20 vite në treg",
      warranty: "Garanci për klientin",
      support: "Servis Profesional",
      follow: "Na Ndiqni",
      featuredPhones: "Produktet e reja ",
      services: "Shërbimet tona",
      reviews: "Vlerësime nga klientët",
      brandsWeSell: "Markat që ne shesim",
      off: "Ulje në 50%",
      special: "Oferta të limituara për smartphone dhe aksesorë.",
      repair: "Riparime",
      screen: "Zëvendësim ekrani, riparim baterie dhe riparime të bordeve ",
      accesore: "Aksesorë",
      accer: "Mbajtëse, karikues, kufje dhe shumë të tjera.",
      soft: "Shërbimi Softueri",
      software: "Çlirimi, përditësime dhe instalim sisteme.",
      serv: "Shërbimi IT",
      service: "Në shtëpi dhe për biznese",
      review1:
        "Shërbimi më i mirë që kam përjetuar ndonjëherë në Shqipëri! Energji kaq e mrekullueshme nga ekipi — ata e zgjidhën problemin tim vetëm në një orë, ndërsa shërbimet e tjera as nuk morën iniciativën për ta rregulluar atë. Ata janë afër qendrës së Tiranës, kështu që ishte shumë e lehtë t'i gjeja. Faleminderit Masterphone!",
      review2:
        "un kisha nje iphone 12 promax dhe me than qe nuk behet me por te ju gjeta zgjidhjen per 4 ore u be si telefon dhe punon shum ne rregull jeni me te miret",
      review3:
        "Servis korrekt, cuna te sjellshem, mbi te gjitha profesionist per punen qe bejn.Vend ku problemi gjen zgjidhje",
      review4:
        "Ekrani i telefonit tim u dëmtua gjatë stuhisë dhe duhej ta riparoja sa më shpejt të ishte e mundur, kështu që e çova te Master Phone. Isha shumë i kënaqur me shërbimin - shumë i shpejtë, profesional dhe me vlerë të mirë për paratë. Patjetër që do ta rekomandoja!",
      review5:
        "Master Phone vendi ideal per zgjidhje specifike🌟🌟🌟🌟🌟 seria e telefonit tim ka dale me probleme ne qark dhe ne shume vende jam interesuar dhe nuk mora zgjidhje.Master Phone realisht te mbrekullueshem me profesionalizmin e tyre te gjitha te dhenat qe kisha ne cel mu rikthyen me sukses.Perfekt ne cdo detaj 🌟🌟🌟🌟",
      review6:
        "Pas disa vitesh me një problem serioz me Samsung S10 Plus, ajo që më interesonte më shumë nuk ishte telefoni, por të dhënat brenda tij (data recovery). Fatkeqësisht, pasi e çova në disa nga serviset “më të njohura” në Tiranë, jo vetëm që nuk arritën të bëjnë asgjë, por në disa dëmtuan edhe më shumë duke thene qe esht e pamundur te behet dhe mos u lodh me kot.Masterphone e pashe ne instagram dhe mu ngjall nje shprese.Kur e çova te Master Phone, sinqerisht nuk kisha më shumë shpresë. Por ndryshe nga të tjerët që vetëm eksperimentojnë, këtu gjeta profesionalizëm të vërtetë. Me punë të kujdesshme dhe dije teknike reale, arritën të bëjnë atë që të tjerët nuk e bënë dot: rikuperimin e të dhënave dhe rikthimin e telefonit në gjendje pune.Dallimi është i qartë: disa servise thjesht provojnë fatin, ndërsa këta dinë çfarë bëjnë.Pa diskutim ndër më të mirët në Tiranë. Nëse keni problem serioz dhe sidomos për data recovery, mos humbni kohë kot diku tjetër.",
      buynow: "Bli Tani",
    },

    en: {
      heroTitle: "Latest Technology in Your Hands",
      heroSub: "Smartphones, accessories & professional service",
      explore: "View Offers",
      offers: "Special Offers",
      about: "About Us",
      aboutText:
        "Masterphone is your trusted destination for smartphone and mobile technology services in the heart of Tirana. With 20 years of experience in repairing phones, devices, and accessories, we offer fast, secure, and high-quality services.Our professional team is dedicated to providing immediate solutions for any technical issue, always focusing on customer satisfaction. From screen and battery repairs to device setups and tips for optimal usage, Masterphone Tirana is your reliable partner in the world of mobile technology.Visit Masterphone and experience a service that combines professionalism, dedication, and trustworthiness.",
      why: "Why Choose Us?",
      fast: "20 Years in Market",
      warranty: "Secure Warranty",
      support: "Professional Service",
      follow: "Follow Us",
      featuredPhones: "New products",
      services: "Our Services",
      reviews: "Customer Reviews",
      brandsWeSell: "Brands We Sell",
      off: "50% off",
      special: "Limited offers for smartphones and accessories.",
      repair: "Phone Repairs",
      screen: "Screen replacement, battery repair, and motherboard repairs",
      accesore: "Accessories",
      accer: "Mounts, chargers, headphones, and many more.",
      soft: "Software Services",
      serv: "Software IT Service at Home and for Businesses",
      software: "Unlocking, updates, and system installations.",
      serv: "IT Service ",
      service:"At Home and for Businesses",
      review1:
        "The best service I have ever experienced in Albania! Such wonderful energy from the team — they solved my problem in just one hour, while other services didn’t even take the initiative to fix it. They are close to the center of Tirana, so it was very easy to find them. Thank you, Masterphone!",
      review2:
        "I had an iPhone 12 Pro Max and was told it couldn’t be fixed, but at your place I found the solution — in 4 hours it was like a new phone and works perfectly. You are the best!",
      review3:
        "Correct service, polite guys, above all professionals in the work they do. A place where problems get solved.",
      review4:
        "My phone screen was damaged during a storm and I needed it repaired as soon as possible, so I took it to Master Phone. I was very satisfied with the service — very fast, professional, and great value for money. I would definitely recommend it!",
      review5:
        "Master Phone is the ideal place for specific solutions 🌟🌟🌟🌟🌟. My phone series had circuit problems and in many places I inquired but found no solution. Master Phone was truly amazing — with their professionalism, all the data I had on the phone was successfully recovered. Perfect in every detail 🌟🌟🌟🌟",
      review6:
        "After several years with a serious problem on a Samsung S10 Plus, what mattered most to me wasn’t the phone, but the data inside (data recovery). Unfortunately, after taking it to several of the “most known” services in Tirana, not only did they fail to do anything, but some even caused more damage, saying it was impossible and not to waste my time. I saw Masterphone on Instagram and it gave me hope. When I took it to Master Phone, honestly, I had no more hope. But unlike others who just experiment, here I found true professionalism. With careful work and real technical knowledge, they managed to do what others couldn’t: recover the data and restore the phone to working condition. The difference is clear: some services just try their luck, while these guys know what they are doing. Without a doubt, among the best in Tirana. If you have a serious problem, especially data recovery, don’t waste time elsewhere.",
      buynow: "Buy Now",
    },
  };

  const text = t[lang] || t.sq; // Use correct translations based on selected language

  return (
    <div className="home">
      {/* HERO SECTION */}
      <section
        className="hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>{text.heroTitle}</h1>
          <p>{text.heroSub}</p>
        </div>
      </section>

      {/* OFFERS SECTION */}
      <section className="offers">
        <h2>{text.offers}</h2>
        <div className="offer-card">
          <img src={offer1} alt="offer" />
          <div className="offer-text">
            <h3>{text.off}</h3>
            <p>{text.special}</p>
            <button className="btn-secondary"
             onClick={() => navigate("/shop")}>{text.explore}</button>
          </div>
        </div>
      </section>

      {/* FEATURED PRODUCTS SECTION */}
<section className="featured">
  <h2>{text.featuredPhones}</h2>

  <div className="carousel-container">
    <button
      className="arrow left"
      onClick={() => index > 0 && setIndex(index - 1)}
    >
      ❮
    </button>

    <div className="carousel">
      {[...products]
        .filter((p) => p.is_published)
        .slice(-6)
        .slice(index, index + (isMobile ? 1 : 5))
        .map((product) => (
          <div
            className="product-card"
            key={product.id}
            onClick={() =>
              navigate(`/product/${product.brand}/${product.model}`)
            }
            style={{ cursor: "pointer" }}
          >
            <img
              src={`${API_BASE_URL}/uploads/${product.images}`}
              alt={product.name}
            />

            <h4>{product.name}</h4>

            <p>{Number(product.price).toFixed(2)} €</p>

            <button
              className="btn-secondary"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/product/${product.brand}/${product.model}`);
              }}
            >
              {text.buynow}
            </button>
          </div>
        ))}
    </div>

    <button
      className="arrow right"
      onClick={() =>
        index <
          [...products].filter((p) => p.is_published).length -
            (isMobile ? 1 : 5) &&
        setIndex(index + 1)
      }
    >
      ❯
    </button>
  </div>
</section>

      {/* SERVICES SECTION */}
      <section className="services">
        <h2>{text.services}</h2>
        <div className="services-grid">
          <div className="service-card">
            <div className="icon">
              <i className="fas fa-tools"></i>
            </div>
            <h3>{text.repair}</h3>
            <p>{text.screen}</p>
          </div>
          <div className="service-card">
            <div className="icon">
              <i className="fas fa-mobile-alt"></i>
            </div>
            <h3>{text.accesore}</h3>
            <p>{text.accer}</p>
          </div>
          <div className="service-card">
            <div className="icon">
              <i className="fas fa-laptop-code"></i>
            </div>
            <h3>{text.soft}</h3>
            <p>{text.software}</p>
          </div>

            <div className="service-card">
            <div className="icon">
              <i className="fas fa-building"></i>
            </div>
            <h3>{text.serv}</h3>
            <p>{text.service}</p>
          </div>
        </div>
      </section>



      <section className="why">
        <h2>{text.why}</h2>
        <div className="why-grid">
          <div className="why-card">
            <img src={yearsIcon} alt="Years" className="why-icon" />
            <span>{text.fast}</span>
          </div>
          <div className="why-card">
            <img src={guaranteeIcon} alt="Guarantee" className="why-icon" />
            <span>{text.warranty}</span>
          </div>
          <div className="why-card">
            <img
              src={professionalIcon}
              alt="Professional"
              className="why-icon"
            />
            <span>{text.support}</span>
          </div>
        </div>
      </section>

      {/* OTHER SECTIONS */}
      <section className="about">
        <div className="about-card">
          <h2>{text.about}</h2>
          <p>{text.aboutText}</p>
        </div>
      </section>

 <section className="reviews">
  <h2>{text.reviews}</h2>
  <Slider
    dots={true}
    infinite={true}
    speed={500}
    slidesToShow={1} // show one review at a time
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={6000} // change speed if you like
  >
    {[text.review6, text.review2, text.review3, text.review4, text.review5, text.review1].map(
      (review, i) => (
        <div className="review-card" key={i}>
          <div className="icon">
            <i className="fas fa-quote-left"></i>
          </div>
          <p>{review}</p>
        </div>
      )
    )}
  </Slider>
</section>

      <section className="brands">
        <h2>{text.brandsWeSell}</h2>
        <div className="brand-logos">
          <img src={apple} alt="Apple" />
          <img src={samsung} alt="Samsung" />
          <img src={xiaomi} alt="Xiaomi" />
          <img src={huawei} alt="Huawei" />
        </div>
      </section>
    </div>
  );
}
